/**
 * Current-preview external store (Lane Q6). Holds the App instance rendered
 * by /preview so the route components can read it across navigations without
 * a router loader (loaders are where the PocketBase coupling lives - the
 * preview deliberately has none).
 */
import { useSyncExternalStore } from "react";
import type { App, AppSpecifier } from "@data-root/types";

export interface ActivePreview {
  previewId: string;
  /** monotonic render sequence; doubles as the React remount key */
  seq: number;
  app: App;
  appSpecifier: AppSpecifier;
}

let current: ActivePreview | null = null;
let seqCounter = 0;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export const previewStore = {
  get(): ActivePreview | null {
    return current;
  },
  set(preview: ActivePreview | null): void {
    current = preview;
    emit();
  },
  nextSeq(): number {
    seqCounter += 1;
    return seqCounter;
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useActivePreview(): ActivePreview | null {
  return useSyncExternalStore(previewStore.subscribe, previewStore.get, previewStore.get);
}
